import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { IncomeTaxSummarySection } from 'Components/Universal/Questionnaire/Sections/IncomeDetails';


const IncomeTaxSectionPicker = ({ clientResource, ...rest }) => {
  return pickFunction(clientResource, {
    [fr.relationships.default.name]: () => <IncomeTaxSummarySection {...rest} />,
  });
};

export default IncomeTaxSectionPicker;
